import { render, staticRenderFns } from "./CardContratoHistorico.vue?vue&type=template&id=cedb2158&lang=pug"
import script from "./CardContratoHistorico.vue?vue&type=script&lang=js"
export * from "./CardContratoHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports